import { API, createJsonHeaders } from "app/api";
import {
  CREATE_RATING,
  QUERY_RATINGS,
  DELETE_RATING,
  API_BASE_URL
} from "./constants";

export const createRating = params => {
  const { proposalId, userId } = params;
  const url = `${API_BASE_URL}/resources/ratings/`;
  const body = JSON.stringify({ proposalId, userId });
  const headers = createJsonHeaders(body);
  const request = new Request(url, {
    method: "POST",
    credentials: "same-origin",
    headers,
    body
  });
  return {
    type: API,
    payload: {
      request,
      params,
      ...CREATE_RATING
    }
  };
};

export const deleteRating = params => {
  const { ratingId } = params;
  const url = `${API_BASE_URL}/resources/ratings/${ratingId}`;
  const request = new Request(url, {
    method: "DELETE",
    credentials: "same-origin"
  });
  return {
    type: API,
    payload: {
      request,
      ratingId,
      ...DELETE_RATING
    }
  };
};

export const queryRatings = (params, actionCreators = []) => {
  const url = `${API_BASE_URL}/query/ratings`;
  const { proposalId, userId } = params;
  const body = JSON.stringify({ proposalId, userId });
  const headers = createJsonHeaders(body);
  const request = new Request(url, {
    method: "POST",
    credentials: "same-origin",
    headers,
    body
  });
  return {
    type: API,
    payload: {
      request,
      params,
      actionCreators,
      ...QUERY_RATINGS
    }
  };
};



// WEBPACK FOOTER //
// ./src/app/ratings/actions.js